
// import { useQuery } from '@tanstack/react-query';
// import appointmentServices from '../services/appointment.service';

// export const useAppointments = ({
//   page = 1,
//   limit = 10,
//   status,
//   type, // 🔥 changed from bookingType → type
//   startDate,
//   endDate,
//   search,
// } = {}) => {
//   return useQuery({
//     queryKey: [
//       'appointments',
//       page,
//       limit,
//       status,
//       type,
//       startDate,
//       endDate,
//       search,
//     ],
//     queryFn: () =>
//       appointmentServices.getAppointments({
//         page,
//         limit,
//         status,
//         type,
//         startDate,
//         endDate,
//         search,
//       }),
//     staleTime: 30 * 1000,
//     gcTime: 5 * 60 * 1000,
//     refetchOnWindowFocus: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import appointmentServices from '../services/appointment.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all appointments
 */
export const useAppointments = ({
  page = 1,
  limit = 10,
  status,
  type = 'property',
  startDate,
  endDate,
  search,
  sortBy = 'scheduledDate',
  sortOrder = 'desc',
} = {}) => {
  return useQuery({
    queryKey: [
      'appointments',
      {
        page,
        limit,
        status,
        type,
        startDate,
        endDate,
        search,
         sortBy,
    sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        const params = {
          page,
          limit,
          ...(status && { status }),
          ...(type && { type }),
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
          ...(search && { search }),
          ...(sortBy && { sortBy }),
  ...(sortOrder && { sortOrder }),
        };

        return await appointmentServices.getAppointments(params);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,

    refetchOnWindowFocus: true,
  });
};